import { getLogger } from './logger';

const { logInfo, logWarn } = getLogger({ name: 'idv2', location: 'check-is-in-iframe' });

// Check whether we are in top most window (aka not in an iframe)
// Some browsers (Internet explorer) may throw an error when
// trying to access window.top if running in an iframe
const checkIsInIframe = () => {
  if (typeof window === 'undefined') {
    logInfo('SSR detected');
    return false;
  }

  try {
    // Deliberately unlogged: every log line already carries this as the `iframe` context attribute.
    return window.self !== window.top;
  } catch (e) {
    logWarn('iframe detection error (assuming iframe)', { error: String(e) });
    return true;
  }
};

export default checkIsInIframe;
